// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PShakeOutlinedSvg from "@fishx/icons-svg/es/asn/PShakeOutlined";
import FishxIcon from '../components/FishxIcon';

var PShakeOutlined = function PShakeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PShakeOutlinedSvg
  }));
};

PShakeOutlined.displayName = 'PShakeOutlined';
export default React.forwardRef(PShakeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PShakeOutlined.js
// module id = 3621
// module chunks = 0